import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ContactUsInfo from "./component";
import { submitContactUs } from "./actions";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    submitContactUsConnect: submitContactUs
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsInfo);
